import { render } from "./ArticleCard.vue?vue&type=template&id=48114f19&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=48114f19&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48114f19"]])

export default __exports__